/** Звук входящего сообщения (`public/message.mp3`). */

import { attachMediaPlaybackUnlockOnGesture } from '@/services/unlockMediaPlayback';

/**
 * Увеличивай при каждой замене файла `public/message.mp3`, иначе возможен старый кеш.
 */
const MESSAGE_MP3_CACHE_BUST = '3';

let audioEl: HTMLAudioElement | null = null;
let resolvedUrl: string | null = null;

/** Абсолютный URL: не зависит от текущего path (`/app/chats/...`), иначе запрос уходит не туда. */
function resolveIncomingMessageSoundUrl(): string {
  const pub = (
    typeof process !== 'undefined' && process.env.PUBLIC_URL ? String(process.env.PUBLIC_URL) : ''
  ).replace(/\/$/, '');
  const path = `${pub}/message.mp3`.replace(/\/{2,}/g, '/');
  if (typeof window !== 'undefined' && window.location?.origin) {
    const u = new URL(path, window.location.origin);
    u.searchParams.set('v', MESSAGE_MP3_CACHE_BUST);
    return u.href;
  }
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}v=${encodeURIComponent(MESSAGE_MP3_CACHE_BUST)}`;
}

export function playIncomingMessageSound(): void {
  if (typeof window === 'undefined') return;
  attachMediaPlaybackUnlockOnGesture();
  try {
    const url = resolveIncomingMessageSoundUrl();
    if (!audioEl || resolvedUrl !== url) {
      audioEl = new Audio(url);
      resolvedUrl = url;
      audioEl.preload = 'auto';
    }
    audioEl.currentTime = 0;
    void audioEl.play().catch(() => {
      /* autoplay: needs a prior gesture — unlockMediaPlayback */
    });
  } catch {
    /* */
  }
}
